import { render, staticRenderFns } from "./StagingEditorContainer.vue?vue&type=template&id=d00d880a"
import script from "./StagingEditorContainer.vue?vue&type=script&lang=ts"
export * from "./StagingEditorContainer.vue?vue&type=script&lang=ts"
import style0 from "./StagingEditorContainer.vue?vue&type=style&index=0&id=d00d880a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports